export type PresetKey =
  | 'classic-wood'
  | 'ocean'
  | 'forest'
  | 'modern-slate'
  | 'royal'
  | 'custom'

export interface ThemeColors {
  lane1: string
  lane2: string
  you: string
  opp: string
}

export interface Theme {
  presetKey: PresetKey
  colors: ThemeColors
}

export interface Preset {
  key: Exclude<PresetKey, 'custom'>
  name: string
  colors: ThemeColors
}

export const PRESETS: Preset[] = [
  {
    key: 'classic-wood',
    name: 'Classic Wood',
    colors: {
      lane1: '#e8d9b5',
      lane2: '#6b4a2b',
      you: '#f5efe0',
      opp: '#2b2b2b',
    },
  },
  {
    key: 'ocean',
    name: 'Ocean',
    colors: {
      lane1: '#56c4cf',
      lane2: '#1c3a5e',
      you: '#f0f8ff',
      opp: '#e8633a',
    },
  },
  {
    key: 'forest',
    name: 'Forest',
    colors: {
      lane1: '#a9cf72',
      lane2: '#244a2e',
      you: '#f5f0d0',
      opp: '#5b2f1a',
    },
  },
  {
    key: 'modern-slate',
    name: 'Modern Slate',
    colors: {
      lane1: '#cdd3da',
      lane2: '#2f3a45',
      you: '#3a9bdc',
      opp: '#f25f5c',
    },
  },
  {
    key: 'royal',
    name: 'Royal',
    colors: {
      lane1: '#d9bf6e',
      lane2: '#4a2c6b',
      you: '#f5e9c8',
      opp: '#1a1a2e',
    },
  },
]

// Labels for the four custom rows, in display order.
export const COLOR_LABELS: { key: keyof ThemeColors; label: string }[] = [
  { key: 'lane1', label: 'Lane color 1' },
  { key: 'lane2', label: 'Lane color 2' },
  { key: 'you', label: 'Your checkers' },
  { key: 'opp', label: 'Opponent checkers' },
]

export const DEFAULT_THEME: Theme = {
  presetKey: 'classic-wood',
  colors: PRESETS[0].colors,
}

export const STORAGE_KEY = 'bg.theme'
